import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Sun, Moon } from 'lucide-react';

const DarkModeToggle = ({ size = 'default', showLabel = false, className = '' }) => {
  const { isDarkMode, toggleTheme } = useTheme();

  const sizeClasses = {
    small: 'w-10 h-6',
    default: 'w-12 h-7',
    large: 'w-14 h-8'
  };

  const iconSizes = {
    small: 12,
    default: 14,
    large: 16
  };

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {showLabel && (
        <span className={`text-sm font-medium ${isDarkMode ? 'text-white' : 'text-gray-700'}`}>
          {isDarkMode ? 'Dark' : 'Light'}
        </span>
      )}
      
      <button
        onClick={toggleTheme}
        className={`${sizeClasses[size]} relative inline-flex items-center rounded-full border-2 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 ${
          isDarkMode
            ? 'bg-gray-700 border-gray-600 focus:ring-gray-500'
            : 'bg-gray-200 border-gray-300 focus:ring-gray-400'
        }`}
        aria-label={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
      >
        {/* Toggle Circle */}
        <span
          className={`inline-block transform rounded-full bg-white shadow-lg transition-transform duration-300 ${
            size === 'small' ? 'h-4 w-4' : size === 'large' ? 'h-6 w-6' : 'h-5 w-5'
          } ${
            isDarkMode 
              ? (size === 'small' ? 'translate-x-4' : size === 'large' ? 'translate-x-6' : 'translate-x-5') 
              : 'translate-x-1'
          }`}
        >
          {/* Icon inside the toggle circle */}
          <div className="flex items-center justify-center h-full">
            {isDarkMode ? (
              <Moon size={iconSizes[size]} className="text-gray-700" />
            ) : (
              <Sun size={iconSizes[size]} className="text-yellow-500" />
            )}
          </div>
        </span>
      </button>
    </div>
  );
};

export default DarkModeToggle;
